/**
 * Aggregates client/employer/agent data across multiple fund objects.
 * Picks the "strongest" (non-empty) value for each field.
 */

const isWeak = (v) => !v || v === "5" || v === "0" || v === "לא ידוע" || v === "לא רלוונטי";

export function aggregateClient(funds) {
  if (!funds?.length) return null;
  const res = { ...funds[0].client };
  funds.forEach(f => {
    const c = f.client;
    if (!c) return;
    Object.keys(c).forEach(key => {
      if (isWeak(res[key]) && !isWeak(c[key])) {
        res[key] = c[key];
      } else if (!res[key] && c[key]) {
        res[key] = c[key];
      }
      if (key === "children" && (!res[key] || res[key] === 0) && c[key] > 0) {
        res[key] = c[key];
      }
    });
  });
  return res;
}

export function aggregateEmployer(funds) {
  if (!funds?.length) return null;
  const res = { ...funds[0].employer };
  funds.forEach(f => {
    const e = f.employer;
    if (!e) return;
    Object.keys(e).forEach(key => {
      if (!res[key] && e[key]) res[key] = e[key];
    });
  });
  return res;
}

export function aggregateAgent(funds) {
  if (!funds?.length) return null;
  const res = { ...funds[0].agent };
  funds.forEach(f => {
    const a = f.agent;
    if (!a) return;
    Object.keys(a).forEach(key => {
      if (!res[key] && a[key]) res[key] = a[key];
    });
  });
  return res;
}
